
<template>
  <div class="audience">
    <confirm ref="confirm"></confirm>
    <v-progress-linear
      v-show="progressBar"
      slot="progress"
      color="blue"
      indeterminate
    />

    <v-container class="my-1">
      <v-layout row Wrap>
        <v-flex xs12 sm12 lg12
          ><v-card-text
            v-text="PageTitle"
            class="subtitle-1 indigo--text"
          ></v-card-text>
        </v-flex>
      </v-layout>

      <v-layout row Wrap>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs2 sm3 lg2>
          <v-card-actions>
            <v-btn
              color="blue darken-1"
              text
              @click="editnow"
              :disabled="WhenEdit  || !DataReady"
              v-bind:class="{
                'd-none': WhenEdit || this.$route.params.Activity_id == '0',
              }"
            >
              <v-icon>mdi-pencil</v-icon>
              Edit
            </v-btn>

            <v-btn
              color="green darken-1"
              text
              @click="savenow"
              :disabled="!WhenEdit || !DataReady"
              v-bind:class="{ 'd-none': !WhenEdit }"
            >
              <v-icon>mdi-update</v-icon>
              Save
            </v-btn>
          </v-card-actions>
        </v-flex>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs3 sm3 lg2>
          <v-card-actions>
            <v-btn
              color="green darken-1"
              text
              @click="addnewnow"
              :disabled="WhenEdit || !DataReady"
              v-bind:class="{ 'd-none': WhenEdit }"
            >
              <v-icon>mdi-new-box</v-icon>
              New
            </v-btn>
          </v-card-actions>
        </v-flex>
        <v-flex xs1 sm1 lg1> </v-flex>

        <v-flex xs2 sm3 lg2>
          <v-card-actions>
            <v-btn
              color="red darken-1"
              text
              @click="deletenow"
              :disabled="WhenEdit  || !DataReady"
              v-bind:class="{ 'd-none': WhenEdit }"
            >
              <v-icon>mdi-delete</v-icon>
              Delete
            </v-btn>

            <v-btn
              color="orange darken-1"
              text
              @click="cancelnow"
              :disabled="!WhenEdit || !DataReady"
              v-bind:class="{ 'd-none': !WhenEdit }"
            >
              <v-icon>mdi-cancel</v-icon>
              Cancel
            </v-btn>
          </v-card-actions>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm11 lg8>
          <v-text-field
            v-model="Company_Namefield"
            label="Company"
            class="text-Readonly"
            readonly
            filled
            disabled
            v-show="Showcompany"
          >
            <template v-slot:append>
              <v-btn
                color="blue darken-1"
                text
                @click="gotocompany"
                :disabled="WhenEdit"
              >
                <v-icon>mdi-magnify</v-icon>
                show
              </v-btn>
            </template>
          </v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm11 lg8>
          <v-text-field
            v-model="Emailfield"
            label="Email Address"
            type="email"
            :disabled="!WhenEdit"
            :readonly="!alloweditemail"
          >
          </v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm5 lg3>
          <v-text-field
            v-model="Titlefield"
            label="Title"
            :disabled="!WhenEdit"
            ref="Title"
          >
          </v-text-field>
        </v-flex>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm5 lg4>
          <v-text-field
            v-model="Salutationfield"
            label="Salutation"
            :disabled="!WhenEdit"
          >
          </v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row Wrap>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm5 lg3>
          <v-text-field
            v-model="FirstNamefield"
            label="First Name"
            :disabled="!WhenEdit"
          >
          </v-text-field>
        </v-flex>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm5 lg4>
          <v-text-field
            v-model="LastNamefield"
            label="Last Name"
            :disabled="!WhenEdit"
          >
          </v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row Wrap>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm5 lg3>
          <v-text-field
            v-model="PhoneNumberfield"
            label="Phone Number"
            :disabled="!WhenEdit"
          >
          </v-text-field>
        </v-flex>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm5 lg4>
          <v-text-field
            v-model="MobileNumberfield"
            label="Mobile Number"
            :disabled="!WhenEdit"
          >
          </v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row Wrap>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm5 lg3>
          <v-text-field
            v-model="Departmentfield"
            label="Department"
            :disabled="!WhenEdit"
          >
          </v-text-field>
        </v-flex>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm5 lg4> </v-flex>
      </v-layout>

      <v-layout row Wrap>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm5 lg3>
          <v-text-field
            readonly
            disabled
            v-model="mc_statusfield"
            label="Status"
            class="text-Readonly"
          >
          </v-text-field>
        </v-flex>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm5 lg4>
          <v-text-field
            readonly
            disabled
            v-model="mc_reasonfield"
            label="Status Reason"
            class="text-Readonly"
          >
          </v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row Wrap>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm5 lg3>
          <v-text-field
            readonly
            disabled
            v-model="Lastupdatefield"
            label="Last Update"
            class="text-Readonly"
          >
          </v-text-field>
        </v-flex>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm5 lg4>
          <v-text-field
            readonly
            disabled
            v-model="LastupdateByfield"
            label="Last Update By"
            class="text-Readonly"
          >
          </v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row Wrap>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm5 lg3>
          <v-text-field
            readonly
            disabled
            v-model="mc_lastupdatefield"
            label="MC Last Update"
            class="text-Readonly"
          >
          </v-text-field>
        </v-flex>
        <v-flex xs1 sm1 lg1>
          <v-subheader></v-subheader>
        </v-flex>
        <v-flex xs11 sm5 lg4>
          <v-checkbox
            v-model="mc_tobeupdatedfield"
            :label="'in sync queue'"
            class="text-Readonly darken-1 label-Color"
            readonly
            disabled
          ></v-checkbox>
        </v-flex>
      </v-layout>

      <v-layout row Wrap>
        <v-flex xs1 sm1 lg1>
          <v-subheader></v-subheader>
        </v-flex>
        <v-flex xs11 sm5 lg3>
          <v-checkbox
            v-model="mc_pushstatusfield"
            :label="'in sync queue for status'"
            class="text-Readonly label-Color"
            disabled
            readonly
          ></v-checkbox>
        </v-flex>
        <v-flex xs1 sm1 lg1>
          <v-subheader></v-subheader>
        </v-flex>
        <v-flex xs11 sm5 lg4>
          <v-checkbox
            v-model="mc_archivefield"
            :label="'in sync queue for delete'"
            class="text-Readonly label-Color"
            readonly
            disabled
          ></v-checkbox>
        </v-flex>
      </v-layout>

      <v-layout row Wrap>
        <v-flex xs1 sm1 lg1>
          <v-subheader></v-subheader>
        </v-flex>
        <v-flex xs11 sm5 lg3>
          <div class="text-left">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  :disabled="WhenEdit"
                >
                  Actions
                </v-btn>
              </template>
              <v-list shaped>
                <v-subheader>ACTIONS</v-subheader>
                <v-list-item-group v-model="selectedItem" color="primary">
                  <v-list-item
                    v-for="(item, i) in actions"
                    :key="i"
                    @click="actionnow(item.action)"
                  >
                    <v-list-item-icon>
                      <v-icon v-text="item.icon"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title v-text="item.text"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-menu>
          </div>
        </v-flex>
        <v-flex xs1 sm1 lg1>
          <v-subheader></v-subheader>
        </v-flex>
        <v-flex xs11 sm5 lg4> </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>



<script>
// @ is an alias to /src
import Confirm from "@/components/Confirm";
export default {
  watch: {
    $route() {
      this.refreshlist();
    },
  },
  components: { Confirm },
  data() {
    return {
      WhenEdit: false,
      DataReady: false,
      PageTitle: localStorage.getItem("CURPROFILE") + " Audience",
      Company_Namefield: "",
      Emailfield: "",
      Titlefield: "",
      Salutationfield: "",
      FirstNamefield: "",
      LastNamefield: "",
      Departmentfield: "",
      PhoneNumberfield: "",
      MobileNumberfield: "",
      Lastupdatefield: "",
      LastupdateByfield: "",
      mc_statusfield: "",
      mc_reasonfield: "",
      mc_lastupdatefield: "",
      mc_tobeupdatedfield: false,
      mc_pushstatusfield: false,
      mc_archivefield: false,
      Parent_idfield: 0,
      Callactivefield: 0,
      mc_tagsfield: "",
      alloweditemail: false,
      alloweditfield: false,
      Showcompany: false,
      actions: [
        { text: "Subscribe", icon: "mdi-check", action: 1 },
        { text: "Unsubscribe", icon: "mdi-close", action: 2 },
        { text: "Update MailChimp", icon: "mdi-update", action: 3 },
        { text: "Sync MailChimp Status", icon: "mdi-sync", action: 4 },
      ],
    };
  },

  created() {
    this.refreshlist();
  },

  methods: {
    async refreshlist() {
      this.progressBar = true;
      this.DataReady = false;
      this.myJsonResp = await this.PostData(
        "GetAudience",
        JSON.stringify({
          curprofile: localStorage.getItem("CURPROFILE"),
          Email_id: this.$route.params.Email_id,
          Company_id: this.$route.params.Company_ID,
        })
      );
      this.progressBar = false;
      if (this.myJsonResp != "ERROR") {
        this.data = JSON.parse(this.myJsonResp);
        this.Company_Namefield = this.data.Company_Name;
        this.Emailfield = this.data.email;
        this.Titlefield = this.data.Title;
        this.Salutationfield = this.data.Salutation;
        this.FirstNamefield = this.data.FirstName;
        this.LastNamefield = this.data.LastName;
        this.Departmentfield = this.data.Department;
        this.PhoneNumberfield = this.data.PhoneNumber;
        this.MobileNumberfield = this.data.MobileNumber;
        this.Lastupdatefield = this.data.Lastupdate;
        this.LastupdateByfield = this.data.LastupdateBy;
        this.mc_statusfield = this.data.mc_status;
        this.mc_reasonfield = this.data.mc_reason;
        this.mc_lastupdatefield = this.data.mc_lastupdate;
        this.mc_tobeupdatedfield = this.data.mc_tobeupdated;
        this.mc_pushstatusfield = this.data.mc_pushstatus;
        this.mc_archivefield = this.data.mc_archive;
        this.Parent_idfield = this.data.Parent_id;
        this.Callactivefield = this.data.Callactive;
        this.mc_tagsfield = this.data.mc_tags;
        this.alloweditfield = this.data.Allowedit;
        this.WhenEdit = false;
        this.DataReady = true;
        if (this.Parent_idfield == 0) {
          this.Showcompany = false;
        } else {
          this.Showcompany = true;
        }
        if (this.$route.params.Email_id == 0) {
          this.editnow();
        }
      }
    },
    async editnow() {
      if (this.alloweditfield == false) {
        await this.$refs.confirm.open(
          "Security",
          "Access Denied !",
          "",
          "Close",
          { color: "error" }
        );
        return;
      }
      if (this.Emailfield == 0) {
        setTimeout(() => {
          this.alloweditemail = true;
          this.$refs.email.$refs.input.focus();
        });
      } else {
        setTimeout(() => {
          this.alloweditemail = false;
          this.$refs.Title.$refs.input.focus();
        });
      }

      this.WhenEdit = !this.WhenEdit;
    },

    async cancelnow() {
      if (this.$route.params.Email_id == "0") {
        this.$router.back();
      } else {
        this.refreshlist();
      }

      //if this.$route.params.Email_id = 0 then go BACK
    },

    async deletenow() {
      if (this.alloweditfield == false) {
        await this.$refs.confirm.open(
          "Security",
          "Access Denied !",
          "",
          "Close",
          { color: "error" }
        );
        return;
      }

      if (
        await this.$refs.confirm.open("Confirm", "Delete ?", "Yes", "No", {
          color: "error",
        })
      ) {
        this.progressBar = true;
        this.DataReady = false;

        this.myJsonResp = await this.PostData(
          "DeleteAudience",
          JSON.stringify({
            curprofile: localStorage.getItem("CURPROFILE"),
            Email_id: this.$route.params.Email_id,
          })
        );
        this.progressBar = false;
        if (this.myJsonResp != "ERROR") {
          this.data = JSON.parse(this.myJsonResp);
          await this.$refs.confirm.open(
            "Information",
            "Audience queued for deletion, updating MailChimp first.",
            "Close",
            "",
            {
              color: "info",
            }
          );
          this.DataReady = true;

          this.$router.back();
        }
      }
    },
    addnewnow() {
      this.$router.push("/Audience/0/Company/" + this.$route.params.Company_ID);
      this.refreshlist();
    },

    async savenow() {
      this.progressBar = true;
      this.DataReady = false;

      this.myJsonResp = await this.PostData(
        "SaveAudience",
        JSON.stringify({
          curprofile: localStorage.getItem("CURPROFILE"),
          Email_id: this.$route.params.Email_id,
          Parent_id: this.Parent_idfield,
          email: this.Emailfield,
          Callactive: this.Callactivefield,
          FirstName: this.FirstNamefield,
          LastName: this.LastNamefield,
          Salutation: this.Salutationfield,
          Title: this.Titlefield,
          Department: this.Departmentfield,
          PhoneNumber: this.PhoneNumberfield,
          MobileNumber: this.MobileNumberfield,
          mc_tags: this.mc_tagsfield,
          mc_status: this.mc_statusfield,
          mc_pushstatus: this.mc_pushstatusfield,
        })
      );
      this.progressBar = false;
      this.DataReady = true;

      if (this.myJsonResp != "ERROR") {
        this.data = JSON.parse(this.myJsonResp);
        if (this.$route.params.Email_id == 0) {
          await this.$router.replace({
            path:
              "/Audience/" +
              this.data.Email_id +
              "/Company/" +
              this.$route.params.Company_ID,
          });
        }
        await this.refreshlist();
        this.WhenEdit = false;

        await this.$refs.confirm.open(
          "Information",
          "Audience saved",
          "Close",
          "",
          {
            color: "info",
          }
        );
      }
    },
    gotocompany() {
      this.$router.push("/Company/" + this.Parent_idfield);
    },
    async actionnow(selection) {
      this.progressBar = true;
      this.DataReady = false;

      this.myJsonResp = await this.PostData(
        "ActionAudience",
        JSON.stringify({
          curprofile: localStorage.getItem("CURPROFILE"),
          Email_id: this.$route.params.Email_id,
          Action: selection,
          Callactive: this.Callactivefield,
        })
      );
      this.progressBar = false;
      this.DataReady = true;

      if (this.myJsonResp != "ERROR") {
        await this.refreshlist();
        this.WhenEdit = false;

        await this.$refs.confirm.open("Information", "Done", "Close", "", {
          color: "info",
        });
      }
    },
  },
};
</script>